import {
  deepResearchCopyIcon,
  deepResearchSuccessIcon,
  deepResearchURLIcon,
  deepResearchWarningIcon
} from '../../commonImage';

export const getFaviconUrl = (item: { url: string; size?: string }) => {
  let isValidUrl = false;
  try {
    // Throws if invalid
    new URL(item.url);
    isValidUrl = true;
  } catch {
    isValidUrl = false;
  }
  if (!isValidUrl) {
    return deepResearchURLIcon; // fallback icon
  }
  return `https://www.google.com/s2/favicons?domain=${item.url}&sz=${item?.size && item?.size?.length > 0 ? item.size : '16'}`;
};

export const handleFaviconError = (e: React.SyntheticEvent<HTMLImageElement>) => {
  e.currentTarget.src = deepResearchURLIcon;
  (e.currentTarget as HTMLImageElement).onerror = null;
};

export const getCopyStatusIcon = (status: number) => {
  switch (status) {
    case 1:
      return <img src={deepResearchSuccessIcon} alt='copy success icon' />;
    case 2:
      return <img src={deepResearchWarningIcon} alt='copy warning icon' />;
    default:
      return <img src={deepResearchCopyIcon} alt='copy icon' />;
  }
};

export const DOWNLOAD_FILE_TYPES = {
  DOC: 'application/msword',
  DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
};
export const downloadBlob = (content: any, filename: string, contentType: any) => {
  // Create a blob with mentioned content type
  const safeFilename = filename.replace(/[\\\/:\*\?"<>\|]/g, '');
  var blob = new Blob([content], { type: contentType });
  var url = URL.createObjectURL(blob);

  // Create a link to download it
  var exportLink = document.createElement('a');
  exportLink.href = url;
  exportLink.setAttribute('download', safeFilename);
  exportLink.click();
};

export const removeQuotes = (targetValue: string) => {
  return targetValue && targetValue.replace(/^['"]|['"]$/g, '');
};
